import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Title } from '@angular/platform-browser';
import * as pbi from 'powerbi-client';
import { PowerBIEmbed } from 'src/app/_models/powerbi-embed';
import { PowerBIAuthenticationService } from '../_services/powerbi-authentication.service';
import { PortalApiService } from '../../_services/portal-api.service';

@Component({
  selector: 'app-powerbi-viewer',
  templateUrl: './powerbi-viewer.component.html',
  styleUrls: ['./powerbi-viewer.component.css']
})
export class PowerbiViewerComponent implements OnInit {
  powerBICreds: PowerBIEmbed = new PowerBIEmbed();
  isLoading: boolean;
  errorReceived: boolean;
  errorMessage: string = "";
  groupId: string = "";
  reportId: string = "";
  datasetId: string = "";
  pbiConfig: pbi.models.IReportLoadConfiguration;
  @ViewChild('dashboardContainer', { static: false }) dashboardContainer: ElementRef;


  constructor(
    private powerBIAuthenticationService: PowerBIAuthenticationService,
    private route: ActivatedRoute,
    private apiService: PortalApiService,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get('name')) {
      let title = this.route.snapshot.paramMap.get('name');
      this.titleService.setTitle(title + 'Dashboard - Productioneer Portal');
    } else {
      this.titleService.setTitle('Dashboard - Productioneer Portal');
    }

    this.route.queryParams.subscribe((params: Params) => {
      if (params['reportId'] && params['groupId'] && params['datasetId']) {
        this.reportId = params['reportId'];
        this.groupId = params['groupId'];
        this.datasetId = params['datasetId'];
        this.loadDashboard();
      }
    })
  }

  loadDashboard() {
    this.isLoading = true;

    this.apiService.getDashboardAutorization(this.reportId).subscribe(
      data => {
        this.powerBIAuthenticationService.getReportConfiguration(this.groupId, this.reportId, this.datasetId).subscribe(
          (data: any) => {
            this.powerBICreds.embedToken = data.embedToken;
            this.powerBICreds.embedReportId = data.reportId;
            this.powerBICreds.embedUrl = data.embedUrl;
            this.powerBICreds.embedTokenExpiration = JSON.stringify(data.tokenExpiration);

            localStorage.setItem("embedToken", this.powerBICreds.embedToken);
            localStorage.setItem("embedUrl", this.powerBICreds.embedUrl);
            localStorage.setItem("embedReportId", this.powerBICreds.embedReportId);
            localStorage.setItem("embedTokenExpiration", this.powerBICreds.embedTokenExpiration);

            let models = pbi.models;
            let config = {
              type: 'report',
              tokenType: models.TokenType.Embed,
              accessToken: this.powerBICreds.embedToken,
              embedUrl: this.powerBICreds.embedUrl,
              id: this.powerBICreds.embedReportId,
              permissions: models.Permissions.Read,
              datasetBinding: {
                datasetId: this.datasetId
              }
            };

            let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
            let report = powerbi.embed(this.dashboardContainer.nativeElement, config);

            this.isLoading = false;
          },
          err => {
            console.log(err);
            this.errorReceived = true;
            this.errorMessage = err.error || "Unable to display dashboard using current credentials...";
            this.isLoading = false;
          });
      },
      err => {
        console.log(err);
        this.errorReceived = true;
        this.errorMessage = err.error || "You are unathorized to view this dashboard.";
        this.isLoading = false;
      })
  }

  /* TODO: Determine if this is necessary */
  private powerBITokenIsValid() {
    if (typeof window != 'undefined') {
      let tokenExpiration = localStorage.getItem("embedTokenExpiration") || '';

      /* Check expiration against time 5 minutes from now */
      if (tokenExpiration && JSON.parse(tokenExpiration) > ((Date.now() / 1000) + 300)) {
        this.powerBICreds.embedToken = window.localStorage.getItem('embedToken') || '';
        this.powerBICreds.embedTokenExpiration = window.localStorage.getItem('embedTokenExpiration') || '';
        this.powerBICreds.embedReportId = window.localStorage.getItem('embedReportId') || '';
        this.powerBICreds.embedUrl = window.localStorage.getItem('embedUrl') || '';

        return true;
      } else { return false; }
    }
    return false;
  } 

}
